import styled from 'styled-components'

import { Text } from '@h2/components/typography/text'
import { Page } from '@h2/common/components/page'
import { Heading } from '@h2/components/typography/heading'

const PrivoContainer = styled.div`
  margin: 20px 0;
`
const PrivacyPolicy = () => {
  const dsarLink =
    'https://forms.office.com/pages/responsepage.aspx?id=qv1uquImqk6i2pFlS5-u2qa02Mvc-thCoxzMzOnmHcJUOFNaUUpJMURJMUtJV1VIOUU3V0U3TlhKMCQlQCN0PWcu'

  return (
    <Page>
      <Page.Title>Global Privacy Statement</Page.Title>
      <Page.Layout>
        <Page.Content>
          <Text>Effective date: May 05, 2026</Text>
          <Text>Last updated date: October 6, 2025</Text>
          <Heading level={2}>I. Introduction</Heading>
          <Text>
            This Supplement to{' '}
            <a
              href="https://www.powerschool.com/privacy/"
              target="_blank"
              rel="noreferrer">
              Global Privacy Statement
            </a>{' '}
            for PowerSchool Publicly Accessible Product Headed2 (
            <strong>&quot;Headed2 Privacy Supplement&quot;</strong>) provides information
            to you on how PowerSchool Group LLC and its various operating subsidiaries
            (&quot;PowerSchool&quot;) protects the personal information we may collect
            from you when you access our publicly accessible products. This Headed2
            Privacy Supplement describes how PowerSchool Group LLC collects and uses your
            personal information which is a part of the Collected Data processed by our
            publicly accessible products. We also describe how you may exercise your
            personal data rights available under applicable laws.
          </Text>
          <Text>
            This Headed2 Privacy Supplement incorporates by reference, sections I, V-XIV
            of PowerSchool Global Privacy Statement covering our products and solutions
            licensed to school, districts and other educational institutions,
            applicability to various International Privacy laws. References to{' '}
            <strong>&quot;us&quot;, &quot;we&quot;, &quot;our&quot;</strong> or{' '}
            <strong>&quot;PowerSchool&quot;</strong> in this Headed2 Privacy Supplement,
            are referring to PowerSchool. References to “you”, “your” or “User” in this
            Privacy Supplement are referring to the parents of a Candidate, (if a child
            under 13 intending to use the application); or an over 13-year-old individual
            who themselves is a Candidate intending to use the application. For more
            information on how we manage information collected from users 12 or under,
            please see the Children&apos;s Privacy Section.
          </Text>

          <Heading level={2}>II. PUBLICLY ACCESSIBLE PRODUCTS</Heading>
          <Text>
            PowerSchool makes certain solutions directly available to the public. For
            these products, an individual voluntarily accepts the license terms to access
            the solution and expressly consents to PowerSchool’s collection of certain
            personal information. For these publicly accessible products only, PowerSchool
            acts as the data controller of this Collected Data.
          </Text>
          <Heading level={3} variant="font">
            Headed2
          </Heading>
          <Text>
            This application allows offers services related to career literacy for
            individuals via self-assessment activities, data on industry sectors, and
            local opportunities network. The product also provides the ability to connect
            with Navigators – who help individuals facilitate in better understanding of a
            specific career path and guide their journey. The product collects Personal
            Information like name, age, email address, zip code, profession, current job
            details, academic details – degrees obtained, ranks, grades, income,
            investments.
          </Text>
          <Text>
            The personal data of the individual is processed to provide them with useful
            insight, guide the users towards discovery of how they relate to careers, and
            support exploration and planning process. To ensure the safety of the
            collected personal data, PowerSchool collects only required minimal data, no
            excess data is collected or stored in the product. PowerSchool deploys several
            security measures to ensure the integrity and confidentiality of processed
            personal data.
          </Text>
          <Text>
            The product supports the individual rights in the manner by providing the User
            Right to access i.e. view and export their own data and the Right to be
            forgotten i.e. the user can request that their data and the account be deleted
            and the Right to rectification i.e. user can request to make corrections to
            their data. To exercise your privacy rights under state, federal, provincial
            or country privacy legislation related to this application and the Personal
            Information it collects and processes submit your request to{' '}
            <a href={dsarLink} target="_blank" rel="noreferrer">
              Data Subject Access Request
            </a>
            .
          </Text>

          <Heading level={2}>III. OTHER PROVISIONS</Heading>
          <Heading level={3} variant="font">
            A. DATA RETENTION
          </Heading>
          <Text>
            PowerSchool retains Collected Data only for the length of time needed to
            provide services to you, or as long as the account remains active. An account
            is deemed inactive if a user has not logged in after 2 years, at which point
            all account data is deleted. You may submit a request for us to delete your
            Personal Information from the product. You acknowledge this means once we
            process this request, you may not be able to use any of the services of the
            product. We will action deletion requests within 1 month of receipt.
          </Text>
          <Heading level={3} variant="font">
            B. USER CONSENT
          </Heading>
          <Text>
            By clicking on &quot;I ACCEPT&quot; button in response to the Terms of Use
            (&quot;ToU&quot;) presented to you in the Headed2, you consent to our use of
            your personal information, Collected Data, in accordance with the ToU of
            Headed2 and the Global Privacy Statement including this Supplement.
          </Text>
          <Heading level={3} variant="font">
            C. NOTIFICATION REGARDING PRIVACY POLICY UPDATES
          </Heading>
          <Text>
            From time to time, we may update this Headed2 Privacy Supplement and the
            Global Privacy Statement. We encourage you to periodically review these
            documents in case we make changes. If we make a material change to this policy
            in relation to the collection and use of personal information we will post
            notice at the top of this policy and the community portal.
          </Text>
          <Heading level={3} variant="font">
            D. DISCLOSURE OF COLLECTED DATA
          </Heading>
          <Text>
            We may share and disclose Information in the following ways or for any other
            purpose disclosed at the time of collection:
          </Text>
          <Text>
            1. Legal and law enforcement purposes. We may disclose Collected Data in
            response to legal process, for example in response to a court order or a
            subpoena, or in response to a law enforcement agency&apos;s request. We also
            may disclose such Collection Data to third parties: (i) in connection with
            fraud prevention activities, (ii) where we believe it is necessary to
            investigate, prevent, or take action regarding illegal activities, (iii) in
            situations that may involve violations of our terms of use or other rules,
            (iv) to protect our rights.
          </Text>
          <Text>
            2. Change of control. We may transfer Collected Data in the event of a
            business transaction, such as if we or one of our business units or our
            relevant assets are acquired by, sold to, or merged with another company or as
            part of a bankruptcy proceeding or a business reorganization. Such transfer
            would not without more change the scope of your consent given to PowerSchool
            as data controller of the Collected Data.
          </Text>
          <Text>
            3. Additional consent. We may otherwise disclose Collected Data when you
            provide PowerSchool with additional consent to do so.
          </Text>
          <Text>
            Information collected automatically. We collect information about the pages
            your device&apos;s browser visits within the Website, and how your browser
            accesses and uses the Website by using cookies, tracking technologies and
            other third-party analytics tools.
          </Text>
          <Heading level={3} variant="font">
            E. Children&rsquo;s Privacy
          </Heading>
          <Text>
            Kids Privacy Assured by PRIVO: COPPA Safe Harbor Certification PowerSchool
            Holdings, Inc. is a member of the PRIVO Kids Privacy Assured COPPA safe harbor
            certification Program (“the Program”). The Program certification applies to
            the digital properties listed on the certification page that is viewable by
            clicking on the PRIVO Seal. PRIVO is an independent, third- party organization
            committed to supporting online services to safeguard children’s personal
            information collected online. The PRIVO COPPA safe harbor certification Seal
            posted on this page indicates PowerSchool Holdings, Inc. has established COPPA
            compliant privacy practices and has agreed to submit to PRIVO’s oversight and
            consumer dispute resolution process. If you have questions or concerns about
            our privacy practices, please contact us at 1 (916) 790-1509 or
            privacy@powerschool.com. If you have further concerns after you have contacted
            us, you can contact PRIVO directly at{' '}
            <a href="mailto:privacy@privo.com">privacy@privo.com</a>
          </Text>
          <PrivoContainer>
            <a href="https://cert.privo.com/#/companies/powerschoolholdings">
              <img
                src="/images/coppa-seal.png"
                width="140"
                height="70"
                alt="Obtain more information on PRIVO’s certification program and access dispute resolutions for the services"
              />
            </a>
          </PrivoContainer>
          <Text>
            We offer a restricted version of the Headed2 service for children (under 13)
            and teens (13-16). When users ﬁrst create an account, we ask for a date of
            birth which we use to determine the appropriate experience for the age group.
            The user is asked to provide a username, optional ﬁrst name, date of birth,
            state, optional school name and optional graduation year. This information
            helps us create a user proﬁle and provides login credentials to access the
            account.
          </Text>
          <Text>
            We also ask that children provide a parent or guardian email address which we
            use to deliver notice of the child’s participation and to seek consent for the
            use of Headed2. The parent or guardian would need to click the “I CONSENT AND
            ACCEPT” button on their children’s behalf to enable completion of the account
            set up. If the parent does not actively approve the account within 30 days of
            receiving the email, we will promptly delete all information collected from
            the child. Teens must provide their consent to opt-in to the application by
            clicking the “I CONSENT AND ACCEPT” button to evidence their opt-in and to
            complete their account set upon on the application.
          </Text>
          <Text>
            Once consent is provided by parents for children, then they and consenting
            teens can use the resume builder, letter builder and journal features;
            however, any content uploaded by a child will not be shared with Navigators or
            other Explorers. We may also use the child’s email address to contact the
            child, or to respond to inquiries received through our Helpdesk.
          </Text>
          <Text>
            We do not collect personal information from children without prior parental
            consent. If we discover that we have collected a child’s information prior to
            obtaining parental consent, we will take steps to immediately obtain consent
            or delete the collected information. If a child without prior parental consent
            contacts us via our Helpdesk, we will respond once to the child before
            deleting their email address and any personal information submitted through in
            the email body within 48 hours.
          </Text>
          <Text>
            We do not use any of the personal information collected to contact a specific
            individual, serve targeted ads, amass a profile, or for any other purpose
            except as described in this policy.
          </Text>
          <Text>
            We will retain this information for as long as the child or teen’s account
            remains active. If you are a teen or parent/guardian of a child and you would
            like to request access to review, modify or delete your or your child’s
            information, please contact us at the information provided below or by ﬁlling
            the{' '}
            <a href={dsarLink} target="_blank" rel="noreferrer">
              Data Subject Access Request form
            </a>
            .
          </Text>
          <Heading level={4} variant="font">
            Service providers used in relation to children
          </Heading>
          <Text>
            For this application, PowerSchool uses certain service providers. Some service
            providers assist us in processing the personal information you provide to this
            application. A summary of the most relevant service providers for the Headed2
            application and the services they provide the application is below:
          </Text>
          <table>
            <thead>
              <tr>
                <th>Service Provider</th>
                <th>Service</th>
                <th>Location</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Amazon Web Service (AWS)</td>
                <td>Cloud hosting service</td>
                <td>United States</td>
              </tr>
            </tbody>
          </table>
          <br />
          <Text>
            We use Google Analytics to give us insights about how you use the service and
            to help us provide you with the best experience. Google Analytics collects an
            IP address to determine location at a city level only before promptly
            discarding it. Google Analytics does not share any information with any other
            third parties.
          </Text>
          <Text>
            If you or your parent have any questions about the use of service providers,
            please contact us at{' '}
            <a href="mailto:privacy@powerschool.com">privacy@powerschool.com</a>.
          </Text>
          <Heading level={4} variant="font">
            Security
          </Heading>
          <Text>
            Headed2 uses generally accepted security measures and safeguards in an attempt
            to keep the data collected secure and requires that all service providers we
            work with agree to do the same. The measures and safeguards include limiting
            access to the data to those persons who need it to complete their work,
            encryption, using a ﬁre-wall protected environment, and storing all personal
            information in secure operating systems. However, no security safeguards are
            100% secure and we cannot guarantee the security of your information.
          </Text>
          <Heading level={4} variant="font">
            Contact Information
          </Heading>
          <Text>
            If you have any questions about this policy or our collection and use
            practices, please contact us at:
          </Text>
          <Text>
            PowerSchool Holdings, Inc. <br />
            150 Parkshore Dr. Folsom, CA 95630 USA <br />
            1 (916) 790-1509 <br />
            <a href="mailto:privacy@powerschool.com">privacy@powerschool.com</a>
          </Text>
        </Page.Content>
      </Page.Layout>
      <Page.Bottom />
    </Page>
  )
}

export { PrivacyPolicy }
